import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { notificationsState, notificationWSStatusState } from "../../../Recoil/atom";
import api from "../../../api";

const NotificationDropdown = () => {
  const [menu, setMenu] = useState(false);
  const notifications = useRecoilValue(notificationsState);
  const wsStatus = useRecoilValue(notificationWSStatusState);
  const setNotifications = useSetRecoilState(notificationsState);

  // Toggle handler: if opening, trigger fetch
  const toggleMenu = async () => {
    const willOpen = !menu;
    setMenu(willOpen);
    if (willOpen) {
      try {
        await api.post(
          "/v1/notifications/markallviewed",
          {},
          { withCredentials: true }
        );
        // Optimistically update local state so badges drop immediately
        setNotifications((prev) => prev.map((n) => ({ ...n, viewed: 0 })));
      } catch (err) {
        // Non-fatal; dropdown should still open
        // console.error("Failed to mark notifications viewed", err);
      }
    }
  };

  return (
    <li className="dropdown d-inline-block">
      <Dropdown
        isOpen={menu}
        toggle={toggleMenu}
        className="dropdown d-inline-block"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="ri-notification-3-line" />
          {notifications.some((n) => n.viewed === 1) && (
            <span className="noti-dot" />
          )}
        </DropdownToggle>

        <DropdownMenu
          className="dropdown-menu-lg dropdown-menu-end p-0"
          style={{ width: "25rem" }}
        >
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">Notifications</h6>
              </Col>
              <div className="col-auto">
                <span
                  className={`badge ${wsStatus === "connected" ? "bg-success" : "bg-secondary"} me-2`}
                >
                  {wsStatus === "connected" ? "Live" : wsStatus}
                </span>
                <Link to="/notifications" className="small">
                  View All
                </Link>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "230px" }}>
            {notifications.length === 0 ? (
              <p className="text-center my-2">No notifications</p>
            ) : (
              notifications.map((notif) => {
                const imagePath =
                  ["RaceTracks", "Pokemon Gift Received", "Pokemon Gift Sent", "Pokédex", "Auction House"].includes(
                    notif.subject
                  )
                    ? `/sprites/${notif.avatar}.png`
                    : `/avatars/${notif.avatar}.png`;

                return (
                  <div
                    key={notif.id}
                    className="text-reset notification-item"
                  >
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <img
                          src={imagePath}
                          className="rounded-circle avatar-xs"
                          alt="notif-img"
                          style={{ width: 80, height: 80 }}
                        />
                      </div>
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{notif.subject}</h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">{notif.text}</p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {notif.timesent
                              ? new Date(notif.timesent * 1000).toLocaleString()
                              : "Unknown time"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </SimpleBar>

          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 text-center"
              to="/notifications"
            >
              <i className="mdi mdi-arrow-right-circle me-1" /> View More
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </li>
  );
};

export default NotificationDropdown;
